export default "/images/danger-theme.png?26de2d07f3f481b7830c333bc7f369df";